<template lang="pug">
.flex-none.p-4.w-full(class="md:w-1/2 xl:w-1/3")
   .stats-box.stats-box-empty(v-bind:class="{ 'flipped': showBack }")
      .front.h-full
         .flex.h-full.items-center.content-center.justify-center.-mt-6.cursor-pointer(@click='showBack=!showBack')
            .text-6xl +
      .back
         .box-header
            .flex.self-start.justify-between.items-center.mx-4
               i.svg-white(@click='showBack=!showBack')
                  svg(xmlns='http://www.w3.org/2000/svg', width='24', height='24', viewbox='0 0 24 24')
                     path(d='M13.4 12l5.3-5.3c0.4-0.4 0.4-1 0-1.4s-1-0.4-1.4 0l-5.3 5.3-5.3-5.3c-0.4-0.4-1-0.4-1.4 0s-0.4 1 0 1.4l5.3 5.3-5.3 5.3c-0.4 0.4-0.4 1 0 1.4 0.2 0.2 0.4 0.3 0.7 0.3s0.5-0.1 0.7-0.3l5.3-5.3 5.3 5.3c0.2 0.2 0.5 0.3 0.7 0.3s0.5-0.1 0.7-0.3c0.4-0.4 0.4-1 0-1.4l-5.3-5.3z')
               h3 Add a new Website
               i.svg-white(@click='showBack=!showBack')
                  //- svg(xmlns='http://www.w3.org/2000/svg', width='24', height='24', viewbox='0 0 24 24')
                  //-    path(d='M21.7 7.3l-5-5c-0.2-0.2-0.4-0.3-0.7-0.3h-11c-1.7 0-3 1.3-3 3v14c0 1.7 1.3 3 3 3h14c1.7 0 3-1.3 3-3v-11c0-0.3-0.1-0.5-0.3-0.7zM16 20h-8v-6h8v6zM20 19c0 0.6-0.4 1-1 1h-1v-7c0-0.6-0.4-1-1-1h-10c-0.6 0-1 0.4-1 1v7h-1c-0.6 0-1-0.4-1-1v-14c0-0.6 0.4-1 1-1h1v4c0 0.6 0.4 1 1 1h8c0.6 0 1-0.4 1-1s-0.4-1-1-1h-7v-3h7.6l4.4 4.4v10.6z')
         .box-body
            .mt-8.mx-4(v-if='preSave')
               .mt-2
                  label.settings-input-label(for='account') Account
                  .relative
                     select#account.settings-select(v-model='properties')
                        option(v-for='account of accounts', v-bind:value='account.properties') {{account.name}}
                     .select-icon-wrap
                        .select-icon
                  label.settings-input-label(for='property') Property
                  .relative
                     select#property.settings-select(v-model='profiles')
                        option(v-for='property of properties', v-bind:value='property') {{property.name}} – {{ property.id}}
                     .select-icon-wrap
                        .select-icon
                  label.settings-input-label(for='view') View
                  .relative
                     select#property.settings-select(v-model='view')
                        option(v-for='profile of profiles.profiles', v-bind:value='profile.id') {{profile.name}}
                     .select-icon-wrap
                        .select-icon
                  button.bg-blue.text-white.font-bold.py-2.px-4.mt-4.rounded(@click='savePage', class='hover:bg-blue-dark') Save
            .mx-4(v-else)
               .mt-4
                  label.settings-input-label name
                  input.settings-input(v-model='page.name', placeholder='Name')
               .mt-4
                  label.settings-input-label favicon url
                  input.settings-input(v-model='page.favicon', placeholder='Favicon')
               .mt-4
                  dropdown(v-model='settings.timeframe', label='timeframe', :options='dropdownOptions.timeframe')
               .flex.mt-4
                  .flex-1.mr-4
                     dropdown(v-model='settings.bigNumber', label='big number', :options='dropdownOptions.bigNumber')
                  .flex-1
                     dropdown(v-model='settings.graph', label='graph', :options='dropdownOptions.graph')
               .flex.mt-4
                  .flex-1.mr-4
                     dropdown(v-model='settings.topLeft', label='top left', :options='dropdownOptions.others')
                  .flex-1
                     dropdown(v-model='settings.topRight', label='top right', :options='dropdownOptions.others')
               .flex.mt-4
                  .flex-1.mr-4
                     dropdown(v-model='settings.bottomLeft', label='bottom left', :options='dropdownOptions.others')
                  .flex-1
                     dropdown(v-model='settings.bottomRight', label='bottom right', :options='dropdownOptions.others')
               button.bg-blue.text-white.font-bold.py-2.px-4.mt-4.rounded(@click='saveSettings', class='hover:bg-blue-dark') Save
</template>

<script>
import axios from 'axios'
import Dropdown from './Dropdown'
import DropdownOptions from './dropdown-options'
import { EventBus } from '@/components/eventBus'

export default {
  name: 'NewBox',
  components: {
    Dropdown
  },
  props: {
    amount: Number,
    showModal: Function
  },
  created () {
    this.preSave = true

    // const subscriptionTest = JSON.parse(localStorage.getItem('subscription'))
    // if (subscriptionTest && subscriptionTest.status === 'active') {
    //   this.subscription = true
    // }

    axios.get(`google/accounts`).then(res => {
      if (res.status === 200) {
        this.accounts = res.data
      }
    })
  },
  methods: {
    savePage () {
      // check for valid subscription
      const subscriptionTest = JSON.parse(localStorage.getItem('subscription'))
      if (!subscriptionTest && this.amount >= 2) {
        this.showBack = false
        this.properties = []
        this.profiles = []
        this.page = {}
        this.settings = {
          timeframe: 'last7',
          bigNumber: 'realtime',
          graph: 'ga:users',
          topLeft: 'ga:users',
          topRight: 'ga:pageviews',
          bottomLeft: 'ga:avgSessionDuration',
          bottomRight: 'ga:bounceRate'
        }
        this.showModal()
      } else if (this.amount < 2 || (subscriptionTest && subscriptionTest.status === 'active')) {
        const page = {
          name: this.profiles.name,
          url: this.profiles.websiteUrl,
          favicon: 'https://www.google.com/s2/favicons?domain=' + this.profiles.websiteUrl,
          viewId: this.view,
          trackingId: this.profiles.id
        }
        console.log('save: ', page)
        axios.post(`page`, page).then(res => {
          console.log(res)
          if (res.status === 200) {
            this.page = res.data
            this.preSave = false
          }
        })
      }
    },
    saveSettings () {
      this.page.settings = this.settings
      this.page.settings.order = this.amount
      axios.put(`page/` + this.page._id, this.page).then(res => {
        if (res.status === 200) {
          this.page = res.data
          this.preSave = true
          this.showBack = false
          this.properties = []
          this.profiles = []
          this.page = {}
          this.settings = {
            timeframe: 'last7',
            bigNumber: 'realtime',
            graph: 'ga:users',
            topLeft: 'ga:users',
            topRight: 'ga:pageviews',
            bottomLeft: 'ga:avgSessionDuration',
            bottomRight: 'ga:bounceRate'
          }
          EventBus.$emit('fetchPages')
        }
      })
    }
  },
  data () {
    return {
      showBack: false,
      preSave: true,
      accounts: [],
      properties: [],
      profiles: [],
      page: {},
      settings: {
        timeframe: 'last7',
        bigNumber: 'realtime',
        graph: 'ga:users',
        topLeft: 'ga:users',
        topRight: 'ga:pageviews',
        bottomLeft: 'ga:avgSessionDuration',
        bottomRight: 'ga:bounceRate'
      },
      view: '',
      dropdownOptions: DropdownOptions
    }
  }
}
</script>

<style scoped>

.line-chart{
   height: 200px;
   width:90%;
   margin: 0 auto
}

</style>



// WEBPACK FOOTER //
// src/components/modules/NewBox.vue